import styles from './style.module.scss';
import { useEffect, useRef, useState } from 'react';
import dropdownIcon from '../../../assets/dropdownIcon.svg';
import classNames from 'classnames';

interface Option {
  label: string,
  value: string
}
interface Props {
  name: string,
  options: Option[],
  onChange: (selectedOptions: string[]) => void,
}
const Filter = ({ name, options, onChange }: Props) => {
  const [ selectedOptions, setSelectedOptions ] = useState<string[]>([]);
  const [ modal, setModal ] = useState<boolean>(false);
  const modalRef = useRef<HTMLDivElement | null>(null);

  const toggleModal = () => {
    setModal(!modal);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClicks);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClicks);
    };
  }, [ modal ]);

  const handleOutsideClicks = (event: TouchEvent | MouseEvent)=>{
    if(modal&& modalRef.current && !modalRef.current!.contains(event.target as Node)){
      setTimeout(() => setModal(false), 100);
    };
  };

  const toggleOption = (option: string) => {
    let newSelectedOptions = [ ...selectedOptions ];
    if (selectedOptions.includes(option)) {
      newSelectedOptions = newSelectedOptions.filter((o) => o !== option);
    } else {
      newSelectedOptions.push(option);
    }
    setSelectedOptions(newSelectedOptions);
    onChange(newSelectedOptions);
  }

  return (
    <div className={styles.container}>
      <span className={styles.name}>{name} :</span>
      <div className={styles.control} onClick={toggleModal}>
        <p className={styles.controlLabel}>{selectedOptions.length === 0 ? 'Toutes' : (selectedOptions.length === 1 ? options.find(o => o.value === selectedOptions[0])!.label : `${selectedOptions.length} ${name}s`)}</p>
        <img src={dropdownIcon} alt={'dropdown'} className={styles.dropdownIcon}/>
      </div>
      {modal && (
        <div ref={modalRef} className={styles.modal}>
          {options.map((option) => (
            <div key={option.value} className={styles.optionContainer} onClick={() => toggleOption(option.value)}>
              <div className={classNames(styles.optionSelector, selectedOptions.includes(option.value) && styles.optionSelectorSelected)}/>
              <span className={styles.optionText}>{option.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default Filter;
